// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__LBocp","error":"Textarea_error__QMWXp","readonly":"Textarea_readonly__2SMAA","disabled":"Textarea_disabled__237Fw"};